import React from 'react';
import { useTranslation } from 'react-i18next';

import { Loader } from '@ets-global/b2c-website-ui';

import AccountLayout from '../../../components/Layout/Account/AccountLayout';
import UpdateProfile from '../../../components/Account/UpdateProfile';
import { ChangePassword } from '../../../components/Account/ChangePassword';
import NewsletterSubscription from '../../../components/Account/NewsletterSubscription';
import { CIVILITIES } from '../../../graphql/queries';
import { useQuery } from '../../../hooks';

import './styles.scss';

const Information = () => {
  const { t } = useTranslation();
  const {
    data: { civilities },
    loading,
  } = useQuery(CIVILITIES);

  return (
    <AccountLayout title={t('account.settings.title')}>
      {loading && <Loader />}
      {!loading && (
        <>
          <NewsletterSubscription />
          <div className={'account-layout__double-block'}>
            {civilities && <UpdateProfile civilities={civilities} />}
            <ChangePassword />
          </div>
        </>
      )}
    </AccountLayout>
  );
};

export default Information;
